export const TID = {
  header: "app-header",
  headerLogo: "header-logo",
  searchInput: "search-input",
  searchButton: "search-button",
  suggestionItem: "suggestion-item",
  heroSearchInput: "hero-search-input",
  heroSearchButton: "hero-search-button",
  suggestedTickerButton: "suggested-ticker-button",
  errorMessage: "error-message",
  loadingSkeleton: "loading-skeleton",
  stockOverviewCard: "stock-overview-card",
  companyProfile: "company-profile",
  financialTabs: "financial-tabs",
  financialTabTrigger: "financial-tab-trigger",
  chartPriceHistory: "chart-price-history",
  chartRevenue: "chart-revenue",
  chartNetIncome: "chart-net-income",
  chartEps: "chart-eps",
  chartGrossMargin: "chart-gross-margin",
  chartCashflow: "chart-cashflow",
  chartPe: "chart-pe",
  chartCompetitors: "chart-competitors",
  aiScoreRadar: "ai-score-radar",
  aiOverallScore: "ai-overall-score",
  advantageList: "advantage-list",
  riskList: "risk-list",
  competitorTable: "competitor-table",
  newsFeed: "news-feed",
  newsItem: "news-item",
  aiReport: "ai-report",
  aiChatInput: "ai-chat-input",
  aiChatSend: "ai-chat-send",
  aiChatResponse: "ai-chat-response",
  footerDisclaimer: "footer-disclaimer",
};
